export const USOS_SOURCE_BASE = "usos_de_suelo";

export const USOS_LAYERS = [
  { id: "usos_01", label: "Aeropuerto" },
  { id: "usos_02", label: "Asentamiento agricol" },
  { id: "usos_03", label: "Bosque de coníferas" },
  { id: "usos_04", label: "Bosque de frondosas" },
  { id: "usos_05", label: "Casco" },
  { id: "usos_06", label: "Combinación de culti" },
  { id: "usos_07", label: "Combinación de veget" },
  { id: "usos_08", label: "Cultivo herbáceo" },
  { id: "usos_09", label: "Curso de agua" },
  { id: "usos_10", label: "Discontinuo" },
  { id: "usos_11", label: "Ensanche" },
  { id: "usos_12", label: "Extracción minera" },
  { id: "usos_13", label: "Frutal no cítrico" },
  { id: "usos_14", label: "Industrial" },
  { id: "usos_15", label: "Infraestructura de r" },
  { id: "usos_16", label: "Infraestructura de s" },
  { id: "usos_17", label: "Instalación agrícola" },
  { id: "usos_18", label: "Instalación forestal" },
  { id: "usos_19", label: "Lámina de agua artif" },
  { id: "usos_20", label: "Matorral" },
  { id: "usos_21", label: "Olivar" },
  { id: "usos_22", label: "Otros cultivos leños" },
  { id: "usos_23", label: "Pastizal o herbazal" },
  { id: "usos_24", label: "Prado" },
  { id: "usos_25", label: "Red viaria o ferrovi" },
  { id: "usos_26", label: "Servicio Dotacional" },
  { id: "usos_27", label: "Suelo desnudo" },
  { id: "usos_28", label: "Zona verde urbana" },
] as const;

export type UsosLayerId = (typeof USOS_LAYERS)[number]["id"];

export const USOS_LABEL_BY_ID: Record<string, string> = Object.fromEntries(
  USOS_LAYERS.map((x) => [x.id, x.label])
);
